type EventListenerFromData<T> = T extends null ? () => void : (data: T) => void;

type ExtractEventsWithoutData<T extends Record<string, any>> = {
	[Key in keyof T]: T[Key] extends null ? Key : never;
}[keyof T];

export class EventManager<EventsMap extends { [key: string]: unknown }> {
	private _listeners: {
		[Key in keyof EventsMap]?: EventListenerFromData<EventsMap[Key]>[];
	};

	constructor() {
		this._listeners = {};
	}

	subscribe<T extends keyof EventsMap>(
		eventType: T,
		listener: EventListenerFromData<EventsMap[T]>
	) {
		if (!this._listeners[eventType]) {
			this._listeners[eventType] = [];
		}
		this._listeners[eventType]!.push(listener);
	}

	unsubscribe<T extends keyof EventsMap>(
		eventType: T,
		listener: EventListenerFromData<EventsMap[T]>
	) {
		const listeners = this._listeners[eventType];
		if (listeners) {
			this._listeners[eventType] = listeners.filter(
				existingListener => existingListener !== listener
			);
		}
	}

	notify(eventType: ExtractEventsWithoutData<EventsMap>): void;
	notify<T extends keyof EventsMap>(eventType: T, data: EventsMap[T]): void;
	notify<T extends keyof EventsMap>(eventType: T, data?: EventsMap[T]): void {
		this._listeners[eventType]?.forEach(listener => listener(data));
	}
}
